import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


const pulldownDefaultConfig = {
content: '下拉刷新',
height: 40,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '释放后刷新',
loadingContent: '正在刷新...',
clsPrefix: 'xs-plugin-pulldown-'
}

const pullupDefaultConfig = {
content: '上拉加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '释放后加载',
upContent: '上拉加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
}

export default {
name: 'myDesign',
directives: {
TransferDom
},
components: {
Tab,
TabItem,
Scroller,
XButton,
Confirm,
Popup
},
data () {
return {
list: [],
page: 1,
postStatus: '未完成',
pulldownDefaultConfig: pulldownDefaultConfig,
pullupDefaultConfig: pullupDefaultConfig,
noData: false,
showDetails: false,
downUrl: this.$baseURL+'/file/download',

details: {
requireType: '',  //需求分类
projectType: '',  //项目分类
title: '',  //项目名称
pieceCount: '',  //面数
surfaceCount: '',  //面数
reqdate: '',  //截止日期
price: '',  //赏金
qq: '',  //qq
mailbox: '',  //邮箱
phone: '',  //手机号码
detail: '',  //详细描述
}
}
},
methods: {
unfinished () {
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.postStatus = '未完成'
this.loadMore()
},
completed () {
this.$vux.loading.show({
text: ''
})

this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.list = []
this.page = 1
this.postStatus = '已完成'
this.loadMore()
},
designDetail (data,index) {
this.showDetails = true
this.details = data
this.details.index = index
console.log(data)



},
getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
},
fetchData(cb) {
this.$request.post('/designtask/designAssignment',{
page: this.page,
rows: 10,
token: this.getCookie('_token'),
status: this.postStatus
}).then(data => {
if(data.code == 0){
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
cb(data.obj.rows)
console.log(data)
}else{
this.$vux.loading.hide()
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
this.$vux.loading.hide()
console.log(e)
})
},
refresh() {
this.page = 1
this.fetchData(data => {
this.list = data
this.$refs.scrollerBottom.enablePullup()   
this.$refs.scrollerBottom.donePulldown()   
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
this.$vux.toast.show({
type: 'success',
text: '刷新成功'
})
console.log('下拉刷新成功')
})
this.page += 1
},
loadMore() {
this.fetchData(data => {
setTimeout(() => {
this.$vux.loading.hide()
}, 100);
this.$refs.scrollerBottom.enablePullup()
if (data.length < 10) {
this.$refs.scrollerBottom.disablePullup()
}
if(this.page == 1 && data.length == 0){
this.noData = true
this.$refs.scrollerBottom.disablePullup()
}else{
this.noData = false
}
this.list = this.list.concat(data)
this.$refs.scrollerBottom.donePullup()
this.page += 1
})
}
},
created () {

},
mounted() {
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
this.loadMore()
},
}



// WEBPACK FOOTER //
// ./src/views/myDesign/script.js